// «?tutorial=1»: chi arriva da un link (o da «Prova tu» alla fine del giro di lettura) vuole il tutorial aperto. UNA regola sola: la rotta delle fixture (apre il giro) e la Hub del
// Burraco (passa `apriAllAvvio` all'icona della zona comune, che NON legge l'URL) la leggono da qui. Si legge UNA volta, al montaggio. Nessuno storage, nessuna rete.
export const tutorialRichiesto = (search: string): boolean => new URLSearchParams(search).get('tutorial') === '1';

/** La stringa di ricerca SENZA `tutorial`: si legge una volta, poi si toglie dall'URL (con un `replace` del router, mai `window.history`, che desincronizza react-router). */
export const senzaTutorialRichiesto = (search: string): string => {
  const p = new URLSearchParams(search);
  p.delete('tutorial');
  const s = p.toString();
  return s === '' ? '' : `?${s}`;
};

/** Dalla finestra, o `false` dove non c'e` (SSR, un ambiente senza schermo). */
export const tutorialRichiestoDallaFinestra = (): boolean => typeof window !== 'undefined' && tutorialRichiesto(window.location.search);
